import { DateTime } from 'luxon';

export const getCalendarMinMaxRange = () => ({
  min: DateTime.now().minus({ months: 6 }),
  max: DateTime.now().plus({ months: 18 }),
});
